import axios from 'axios'
let BASE_URL = ''
let API_URL = ''
let APP_URL = ''
let API_BASE_URL = ''

if (location.hostname == 'localhost') {
    BASE_URL = 'http://localhost:8080/'
    API_URL = 'http://127.0.0.1:8000/api/'
    APP_URL = 'http://deh_diqcare_sk.local/'
    API_BASE_URL = 'http://127.0.0.1:8000/'
    
}else {
    BASE_URL = 'https://www.appsatkhira.dristieyehospital.com/'
    API_URL = 'https://www.apisatkhira.dristieyehospital.com/api/'
    API_BASE_URL = 'https://www.apisatkhira.dristieyehospital.com/'
    APP_URL = 'https://www.dehsatkhira.dristieyehospital.com/'
}
// else if (location.hostname == 'app.diqcare_satkhira.local' || location.hostname == 'www.app.diqcare_satkhira.local') {
//     BASE_URL = 'http://app.diqcare_satkhira.local/'
//     API_URL = 'http://api.diqcare_satkhira.local/api/'
//     API_BASE_URL = 'http://api.diqcare_satkhira.local/'
//     APP_URL = 'http://diqcare_satkhira.local/'
// } else {
//     BASE_URL = 'http://www.appsatkhira.dristieyehospital.com:8080/'
//     API_URL = 'http://www.apisatkhira.dristieyehospital.com:8080/api/'
//     API_BASE_URL = 'http://www.apisatkhira.dristieyehospital.com:8080/'
//     APP_URL = 'http://dehsk.diqcare.com:8080/'
//
//
// }

const axiosAdmin = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})
axiosAdmin.defaults.headers.common['base_URL'] = BASE_URL;
axiosAdmin.defaults.headers.common['api_URL'] = API_URL;
axiosAdmin.defaults.headers.common['api_base_URL'] = API_BASE_URL;
axiosAdmin.defaults.headers.common['app_URL'] = APP_URL;
axiosAdmin.defaults.headers.common['Authorization'] = localStorage.getItem("token");
export default axiosAdmin